import React, { useState } from "react";

const AdvancedSearch = ({
  searchColumnDetails,
  getDataRequest,
  setIsSearchPopupOpen,
  isSearchPopupOpen,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [isErrorMessageOpen, setIsErrorMessageOpen] = useState(false);
  const [fetchedData, setFetchedData] = useState([]); // State for fetched data

  const searchClickHandler = async () => {
    if (searchValue) {
      const searchConditions = searchColumnDetails
        .map((ele) => {
          let data = {
            selectFieldName: ele.selectFieldName,
            controlType: ele.tblReportControlMaster[0].controlType,
          };
          return data;
        })
        .map((details) => {
          if (details.controlType === "text" || details.controlType === "tab") {
            return `${details.selectFieldName} LIKE '%${searchValue}%'`;
          } else if (details.controlType === "date" || details.controlType === "datetime") {
            return `${details.selectFieldName} = '${searchValue}'`; // Exact match for dates
          } else if (details.controlType === "number") {
            return `${details.selectFieldName} = ${searchValue}`; // Exact match for numbers
          } else {
            return "";
          }
        })
        .filter((ele) => ele !== "")
        .join(" OR ");

      // Fetch data based on the constructed conditions
      const response = await getDataRequest(searchConditions);
      setFetchedData(response.data); // Adjust this based on your API response structure
      console.log(searchConditions);
    } else {
      setIsErrorMessageOpen(true);
    }
  };

  const resetClickHandler = () => {
    setSearchValue("");
    setFetchedData([]); // Clear fetched data on reset
    getDataRequest(""); // Call with empty string to reset
  };

  const changeSearchHandler = (e) => {
    if (isErrorMessageOpen) setIsErrorMessageOpen(false);
    setSearchValue(e.target.value);
  };

  return (
    !!searchColumnDetails.length && (
      <div>
        <div className="row mb-3">
          <div className="col-lg-2">
            <input
              className="form-control"
              style={{ marginTop: "18px" }}
              value={searchValue}
              onChange={changeSearchHandler}
            />
          </div>
          <div className="col-lg-10">
            <div className="BtnGroup">
              <button className="SubmitBtn" onClick={searchClickHandler}>
                Search
              </button>
              <button
                className="SubmitBtn"
                onClick={resetClickHandler}
                disabled={!searchValue}
              >
                Clear
              </button>
              <button
                className="SubmitBtn"
                onClick={() => setIsSearchPopupOpen(!isSearchPopupOpen)}
              >
                {isSearchPopupOpen ? "-" : "+"}
              </button>
            </div>
          </div>
          <div className="col-12 p-0">
            {isErrorMessageOpen && (
              <p style={{ color: "red", marginLeft: "18px" }}>
                Please select at least one value
              </p>
            )}
          </div>
        </div>

        {/* Display fetched data */}
        <div className="col-12">
          {fetchedData.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  {/* Adjust headers based on your data structure */}
                  <th>ID</th>
                  <th>Name</th>
                  <th>Date</th>
                  {/* Add more headers as necessary */}
                </tr>
              </thead>
              <tbody>
                {fetchedData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.id}</td>
                    <td>{item.name}</td>
                    <td>{item.date}</td>
                    {/* Map more fields as necessary */}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No data found.</p>
          )}
        </div>
      </div>
    )
  );
};

export default AdvancedSearch;